import { Camera } from 'lucide-react'
import { format } from 'date-fns'
import type { Booking } from '@/types/booking'

interface CompletedBookingPromptProps {
  booking: Booking
  onAddPhotos: () => void
}

export function CompletedBookingPrompt({ booking, onAddPhotos }: CompletedBookingPromptProps) {
  return (
    <div className="bg-card dark:bg-card/80 border border-primary rounded-[var(--radius)] p-4 mb-6">
      <div className="flex flex-col gap-3">
        {/* Text content */}
        <div>
          <h3 className="text-base font-semibold text-foreground mb-2">
            Session complete?
          </h3>
          <p className="text-sm text-muted-foreground">
            You had a booked session on {format(booking.scheduledTimestamp, 'MMM d, yyyy')}. Add photos of the tattoo to start your timeline!
          </p>
        </div>

        {/* Action button */}
        <button
          onClick={onAddPhotos}
          className="w-full px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg font-medium transition-colors text-sm flex items-center justify-center gap-2"
        >
          <Camera className="w-4 h-4" />
          Add Photos
        </button>
      </div>
    </div>
  )
}

